/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationSharedPeopleSingle200,
  GetApiV1CourseregistrationSharedPeopleSingle401,
  GetApiV1CourseregistrationSharedPeopleSingle500,
  GetApiV1CourseregistrationSharedPeopleSingleQueryParams,
  GetApiV1CourseregistrationSharedPeopleSingleQueryResponse,
} from "../../types/courseRegistrationSharedController/GetApiV1CourseregistrationSharedPeopleSingle.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";
import { ePersonTypeSchema } from "../ePersonTypeSchema.ts";

export const getApiV1CourseregistrationSharedPeopleSingleQueryParamsSchema =
  z.object({
    filter: z.optional(z.string()),
    type: z.optional(
      z
        .lazy(() => ePersonTypeSchema)
        .describe(
          "1 = Employee | 2 = Teaching | 3 = Student | 4 = Monitor | 5 = Seller | 6 = Advisor | 7 = SellerManager | 8 = Coordinator | ",
        ),
    ),
    companyId: z.optional(z.coerce.number().int()),
    activeOnly: z.boolean().default(false),
    id: z.optional(z.coerce.number().int()),
    email: z.boolean().default(false),
    companyManager: z.boolean().default(false),
    isEnrollmentApto: z.boolean().default(false),
    classroomDisciplineId: z.optional(z.coerce.number().int()),
    pageNumber: z.coerce.number().int().default(1),
    pageSize: z.coerce.number().int().default(20),
  }) as unknown as ToZod<GetApiV1CourseregistrationSharedPeopleSingleQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationSharedPeopleSingle200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1CourseregistrationSharedPeopleSingle200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationSharedPeopleSingle401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationSharedPeopleSingle401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationSharedPeopleSingle500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationSharedPeopleSingle500>;

export const getApiV1CourseregistrationSharedPeopleSingleQueryResponseSchema =
  z.lazy(
    () => getApiV1CourseregistrationSharedPeopleSingle200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationSharedPeopleSingleQueryResponse>;
